export enum EmailActionsType {
  LOAD_SHOW = '[Email] Load show',
  SAVE_EMAIL = '[Email] Save email',
  EMAIL_SAVED = '[Email] Email saved',
  SHOW_LOADED = '[Email] Show loaded'
}
